import type { Language } from "@/components/I18nProvider"

export const LANGUAGE_OPTIONS: Array<{
  value: Language
  code: string
  label: string
}> = [
  { value: "en", code: "ENG", label: "English" },
  { value: "ja", code: "JPN", label: "日本語" },
  { value: "vi", code: "VIE", label: "Tiếng Việt" },
  { value: "th", code: "THA", label: "ไทย" },
]
